import * as constants from '../../utils/constants';
import { checkIfHotjarEnable } from '../../utils/helpers';
import IconInfo from '../../assets/infoIcon.svg';
import IconCheck from '../../assets/icon-check.svg';
import IconTimes from '../../assets/icons/ic_times_blue.svg';

const API_URL = process.env.REACT_APP_API_UTI;

const departmentsTemp = [
  {
    text: 'Lima',
    value: 'Lima',
  },
];

const reqData = JSON.stringify({
  request: {
    trace: {
      consumerId: 'WEB',
      channelCode: 'PER',
    },
    payload: {
      idePais: '80',
    },
  },
});

const requestConfig = {
  method: 'post',
  url: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  data: reqData,
};

const infoCardContents = {
  info: {
    icon: IconInfo,
    content: (
      <div className="info">
        Ten en cuenta que en caso el siniestro sea aprobado, la cuenta para el
        reembolso debe ser: BBVA, BCP, Interbank o Scotiabank. En caso
        contrario, te invitamos a realizar la solicitud de atención por&nbsp;
        <a
          href={constants.LINK_PRODUCTOS_BBVA}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            if (checkIfHotjarEnable()) {
              window.digitalData.push({
                action: {
                  group: 'Tramites Siniestros – Protección Tarjeta BBVA',
                  category: 'Ingresa tu información',
                  name: 'Click',
                  label: 'Aquí',
                },
                event: 'trackAction',
              });
            }
          }}
        >
          aquí
        </a>
        .
      </div>
    ),
  },
  valid: {
    icon: IconCheck,
    content: (
      <div className="info">
        <b>Documento de Identidad con póliza vigente</b>
        <br />
        Completa la siguiente información.
      </div>
    ),
  },
  refused: {
    icon: IconTimes,
    content: (
      <div className="info">
        <b>Póliza caducada</b>
        <br />
        No podrás reportar tu siniestro, si tienes dudas o comentarios puedes
        llamar a: <b>(01) 595 9000 opción 3.</b>
      </div>
    ),
  },
  attach: {
    icon: IconCheck,
    content: (
      <div className="info">
        <b>El siniestro ya cuenta con un caso abierto</b>
      </div>
    ),
  },
};

export { infoCardContents, departmentsTemp, requestConfig };
